import React from 'react';
import { Download, FileCheck } from 'lucide-react';
import { useApp } from './AppContext';
import { useTranslation } from '../i18n/TranslationContext';

export function ContractUCMReady() {
  const { downloadUCMContract, downloadContract } = useApp();
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] mb-6">
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 bg-[var(--ucm-light-green)] rounded-full flex items-center justify-center mr-3">
          <FileCheck size={16} className="text-[var(--ucm-dark-green)]" />
        </div>
        <h3 className="font-semibold text-[var(--ucm-text-dark)]">{t('contractStatus.contractProcess')}</h3>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-[var(--ucm-text-medium)]">{t('contractStatus.status')}</span>
          <span className="text-sm font-semibold text-[var(--ucm-success-green)]">{t('contractStatus.ucmReady.status')}</span>
        </div>
        <p className="text-sm text-[var(--ucm-text-medium)] mb-3">
          {t('contractStatus.ucmReady.description')}
        </p>
        
        <div className="text-xs text-[var(--ucm-text-light)] mb-4">
          {t('contractStatus.stepOf', { current: 5, total: 8 })}
        </div>
      </div>

      <div className="space-y-3">
        <button
          onClick={downloadUCMContract}
          className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center"
        >
          <Download size={16} className="mr-2" />
          {t('contractStatus.ucmReady.downloadUCMContract')}
        </button>
        
        <button
          onClick={downloadContract}
          className="w-full h-12 bg-white border border-[var(--ucm-border-light)] text-[var(--ucm-text-dark)] font-semibold rounded-full hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
        >
          <FileCheck size={16} className="mr-2" />
          {t('contractStatus.ucmReady.viewOriginal')}
        </button>
      </div>
    </div>
  );
}